<template>
  <div class="clientLogin defatult-bg"
       style="height:100vh!important;display: flex;flex-direction: column;align-items: center;">
    <input type="text" disabled style="display:none;">
    <div style="width:100%;display: flex;flex-direction: column;justify-content: space-around;align-items: center;">
      <div style="height: 50px;"></div>
      <div class="top-title">
        <img :src="require('@/assets/2025/loginTitle.png')" alt="">
        <!-- 感谢您对高毅资产的信任与支持
        <br>
        现诚挚邀请您出席
        <br>
        高毅资产2026投资报告会 -->
      </div>
      <div style="width: 100%;padding-left: 30px;padding-right: 30px;box-sizing: border-box;">
        <el-form :rules="rules" ref="ruleForm" style="width: 100%;" @submit.native.prevent>
          <el-form-item class="name-item">
            <el-input v-model="name" @input="inputName" placeholder="受邀人姓名"></el-input>
          </el-form-item>
          <el-form-item prop="phone" v-if="phoneShow">
            <el-input v-model="phone" @input="inputPhone" placeholder="手机号"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="width: 100%;flex: 3;display: flex;flex-direction: column;justify-content: space-between;">
      <div class="clientLoginBtnGroup" style="width: 100%;padding-left: 30px;padding-right: 30px;box-sizing: border-box;">
        <van-button type="default" @click="toMeetingStep" :disabled="nextDisabled">
          参会<van-loading type="spinner" v-if="nextDisabled" size="18px" style="display: inline-block;margin-left: 8px;" />
        </van-button>
        <van-button type="default" @click="onRefuse" :disabled="refuseDisabled">
          不参会<van-loading type="spinner" v-if="refuseDisabled" size="18px" style="display: inline-block;margin-left: 8px;" />
        </van-button>
      </div>
    </div>
    <div style="color: #fff;text-align: center;font-size: 12px;transform: scale(0.9);width: 100vw;">
      *本次会议为非公开会议，仅限于受邀请的特定人士参加。未经高毅资产书面同意，请勿对外转发或展示本邀请函，感谢您的理解与支持。
    </div>
    <div style="height: 46px;"></div>
  </div>
</template>

<script>
import {clientCheck, updateClientResult, checkCanEdit} from '@/service/invitationClientApis'
import footerMessage from '@/components/footer-message'
import {Shares} from '@/util/Share'
import { getQueryString, errCatch, webTracing } from '@gyasset/shared/utils';
import lodash from 'lodash'
import {Attend00, Attend01} from "@/util/constants";

export default {
  name: 'clientLogin',
  data() {
    return {
      name: '',
      phone: '',
      clientId: '',
      clientCode: '0',
      rules: {},
      nextDisabled: false,
      refuseDisabled: false,
      showRefuse: false,
      showLog: false,
      phoneShow: false,
      docmHeight: document.documentElement.clientHeight,
      showHeight: document.documentElement.clientHeight,
      hideClass: false,
    }
  },
  watch: {
    showHeight: 'inputType'
  },
  components: {
    'footer-message': footerMessage
  },
  methods: {
    // 检测屏幕高度变化
    inputType() {
      if (!this.timer) {
        this.timer = true
        let that = this
        setTimeout(() => {
          if (that.docmHeight > that.showHeight) {
            this.hideClass = true
          } else if (that.docmHeight <= that.showHeight) {
            this.hideClass = false
          }
          that.timer = false
        }, 20)
      }
    },
    inputName(value) {
      this.name = value
      // this.phoneShow = false
      // console.log("输出name", this.name, value)
    },
    inputPhone(value) {
      this.phone = value
      // console.log("输出name", this.phone, value)
    },
    toClientResult() {
      this.$router.push({name: 'clientResult2024', query: {showLog: '1'}})
    },
    toMeetingStep: lodash.debounce(async function () {
      if (this.nextDisabled) {
        return
      }
      if (!this.name && !this.phone) {
        return
      }
      let phoneReg = /^[0-9]{11}$/
      if (this.phone && !phoneReg.test(this.phone)) {
        this.$message.error('联系电话格式有误，请您再次确认。')
        return
      }
      this.nextDisabled = true
      this.showLog = false
      let checkRes = await clientCheck(this.name, this.phone)
      const [editErr, editRes] = await errCatch(checkCanEdit);
      this.nextDisabled = false
      this.clientId = ''
      let {code, clientId, record, attend, token} = checkRes
      if (code === '0') {
        this.clientId = clientId
        if (record === '1' && attend === Attend01) {
          this.showLog = true
        }
        this.$store.commit('setClientId', this.clientId)
        this.$store.commit('setToken', token)
        
        if (!editRes.data) {
          const queryData = {};
          if (this.showLog) queryData.showInfo = true;
          this.$router.push({
            name: 'meetingResult2024',
            query: queryData,
          })
        } else {
          if (this.showLog) {
            this.toClientResult()
          } else {
            this.$router.push({name: 'meetingStep2024'})
          }
        }
      } else if (code === '0001') {
        this.$message.error('本次会议为非公开会议，仅限于受邀请的特定人士参加，请您与主办方确认。')
      } else if (code === '0002') {
        this.$message.error('请输入您的手机号。')
        this.phoneShow = true
      } else {
        this.$message.error('本次会议为非公开会议，仅限于受邀请的特定人士参加，请您与主办方确认。')
      }
    }, 200, {
      leading: true,
      trailing: false
    }),
    onRefuse: lodash.debounce(async function () {
      if (this.refuseDisabled) {
        return
      }
      if (!this.name && !this.phone) {
        return
      }
      let phoneReg = /^[0-9]{11}$/
      if (this.phone && !phoneReg.test(this.phone)) {
        this.$message.error('联系电话格式有误，请您再次确认。')
        return
      }
      this.refuseDisabled = true
      let checkRes = await clientCheck(this.name, this.phone)
      this.refuseDisabled = false
      this.clientId = ''
      let {code, clientId, token, attend} = checkRes
      if (code === '0') {
        if (attend === Attend00) {
          this.$router.push({name: 'refuseInvitation2024'})
        } else {
          this.clientId = clientId
          this.$store.commit('setToken', token)
          let res = await updateClientResult({attend: Attend00, clientId: this.clientId})
          let {code:codeUpdate, msg} = res
          if (codeUpdate === '0') {
            this.$router.push({name: 'refuseInvitation2024'})
          } else {
            this.$message.error(msg || '服务异常，请联系客服')
          }
        }
      } else if (code === '0001') {
        this.$message.error('本次会议为非公开会议，仅限于受邀请的特定人士参加，请您与主办方确认。')
      } else if (code === '0002') {
        this.$message.error('请输入您的手机号。')
        this.phoneShow = true
      } else {
        this.$message.error('本次会议为非公开会议，仅限于受邀请的特定人士参加，请您与主办方确认。')
      }
    }, 200, {
      leading: true,
      trailing: false
    })
  },
  mounted() {
    this.name = ''
    this.phoneShow = false
    this.phone = ''
    // window.onresize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        this.showHeight = window.screenHeight
      })()
    }
    Shares.shareCode()
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to, 'from', from)
    if (!from.name) {
      next({'name': 'invitationLetter2024'})
    } else {
      next()
    }
  }
}
</script>

<style lang="less">
.clientLogin {
  height: 100vh !important;
  padding: 0 20px;

  .el-form-item__content {
    height: 48px;
    line-height: 48px;

    .el-input__inner {
      height: 48px;
      line-height: 48px;
      border: 0;
    }
  }

  .name-item {
    input {
      text-align: center;
    }
  }

  .top-title {
    padding-bottom: 80px;
    
    > img {
      width: 100%;
    }
  }

  .clientLoginBtnGroup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 60px;

    > button {
      margin-top: 5px;
      width: 100%;
      font-size: 20px;
      font-weight: bold;
      height: 48px;
      margin-bottom: 10px;
      border: 0;
    }

    .refuseMeetingBtn {
      color: #999;
      font-weight: normal;
    }
  }

  .clientLoginRefuseDialog {
    border-radius: 0;
    //position: relative;
  }
}
</style>
